import { createSvgIcon } from '@mui/material';

export const SendIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="m10.0001 18.3333c4.6024 0 8.3333-3.7309 8.3333-8.33331 0-4.60237-3.7309-8.33333-8.3333-8.33333-4.60239 0-8.33335 3.73096-8.33335 8.33333 0 4.60241 3.73096 8.33331 8.33335 8.33331zm-.05204-4.8126c0 .4112.49614.6183.78854.3292l3.5602-3.5207c.1833-.1812.1833-.47719 0-.6584l-3.5602-3.52071c-.2924-.28914-.78854-.08202-.78854.32919v2.59478h-4.57761v1.85184h4.57761z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>,
  'SendIcon',
);
